import { Box, Tabs, Tab } from "@mui/material";
import React from "react";
import LabDetails from "./LabDetails";
import RadiologyDetails from "./RadiologyDetails";
import UploadedDocuments from "./UploadedDocuments";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      className='max-h-[50dvh] overflow-y-auto'
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function DetailsTab({
  id,
  encounterId,
}: {
  id: number;
  /** Encounter context for uploaded-docs API when route has no encounterId */
  encounterId?: number;
}) {
  const [value, setValue] = React.useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          variant="fullWidth"
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Lab details" {...a11yProps(0)} />
          <Tab label="Radiology details" {...a11yProps(1)} />
          <Tab label="Uploaded documents" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <div className="max-h-20dvh overflow-y-auto">
        <CustomTabPanel value={value} index={0}>
          <LabDetails id={id} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <RadiologyDetails id={id} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <UploadedDocuments encounterId={encounterId ?? id} />
        </CustomTabPanel>
      </div>
    </Box>
  );
}

export default DetailsTab;
